export default "__VITE_ASSET__DxTXY9I7__"